//shared containers
import { Footer } from '@/containers-m/Footer';
import { Navigation } from '/containers-m/';
import { Logos, logos_list } from '@/containers-ai/Logos';

import { Proof, proofOutcomes } from '@/containers-ai/Proof';
import { FreightExperts } from '@/containers-ai/FreightExperts';
import { LifecycleRail } from '@/containers-ai/LifecycleRail';

//containers
import { Hero, EndCTA, AICompounding, Rails } from './containers/index';

//styles
import { PageWrapper, HomeGlobalStyle } from './Home.styles';

function Home({ lifecycle_content }) {
  return (
    <PageWrapper>
      <HomeGlobalStyle />
      <Navigation theme="dark" />
      <Hero />
      <Logos logos={logos_list} label={false} />
      <LifecycleRail lifecycle_content={lifecycle_content} />
      <EndCTA variant="top" />
      <FreightExperts />
      <AICompounding />
      <Proof outcomes={proofOutcomes} />
      <Rails />
      <EndCTA variant="bottom" />
      <Footer />
    </PageWrapper>
  );
}

export default Home;
export { Home };
